/** Default stale time for overview/hero queries (ms). */
export const OVERVIEW_STALE_TIME = 60_000;

/** App-wide default from QueryClient (ms). */
export const LIST_STALE_TIME = 30_000;
